import type {Component} from 'grapesjs';
import EditorBaseComponentVO, {type ComponentVOProps} from './editorbasecomponentvo';
import type {ExtendedControlIcons} from './extendedcontrolicons';

export interface SliderVOOptions {
  defaults?: number | string;
  step?: number;
  extendedControls?: boolean;
  extendedControlIcons?: ExtendedControlIcons | null;
  component?: Component | null;
  isResponsive?: boolean;
  toggleProp?: string;
}

export interface SliderVOProps extends ComponentVOProps {
  step: number;
  toggleProp: string;
}

export default class PMWSliderComponentVO extends EditorBaseComponentVO {
  private stepValue: number;
  private togglePropValue: string;

  constructor(
    property: string,
    propertyLabel: string,
    units: string | string[],
    min: number,
    max: number,
    opts: SliderVOOptions = {}
  ) {
    const options = {
      defaults: 0,
      step: 1,
      extendedControls: false,
      extendedControlIcons: null,
      component: null,
      isResponsive: false,
      toggleProp: '',
      ...opts,
    };

    super(
      property,
      propertyLabel,
      units,
      min,
      max,
      options.defaults,
      window.PMW.emails.styles.ID_SLIDER,
      options.extendedControls,
      options.component,
      options.isResponsive,
      options.extendedControlIcons
    );

    this.stepValue = options.step;
    this.togglePropValue = options.toggleProp;
  }

  get step(): number {
    return this.stepValue;
  }

  override set min(value: number) {
    super.min = value;
  }

  override get min(): number {
    return super.min;
  }

  // ESLint disable: This property is used in toObject() and by external code
  // eslint-disable-next-line @typescript-eslint/class-methods-use-this
  get toggleProp(): string {
    return this.togglePropValue;
  }

  // ESLint disable: This setter is used by external code that instantiates the class
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  set toggleProp(value: string) {
    this.togglePropValue = value;
  }

  override toObject(): SliderVOProps {
    const baseObj = super.toObject();
    return {
      ...baseObj,
      step: this.step,
      toggleProp: this.toggleProp,
    };
  }
}